export const getPreviousQuarterAndYear = (year: number, quarter: number) => {
  if (quarter < 1 || quarter > 4) {
    throw new Error('Quarter must be between 1 and 4.')
  }

  const previousQuarter = quarter === 1 ? 4 : quarter - 1
  const previousYear = quarter === 1 ? year - 1 : year

  return {
    year: previousYear,
    quarter: previousQuarter,
  }
}
